/* eslint-disable import/order */
<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Запас в конце страницы, чтобы последние кнопки можно было прокрутить
         выше плашки про cookie и чата (на телефоне закрывали «Отправить»,
         07.10.2026). Высоту считает useFloatingClearance. -->
    <div
      ref="floatingSpacer"
      class="floating-clearance"
      :style="{ height: `${floatingHeight}px` }"
      aria-hidden="true"
    ></div>

    <!-- Кнопка «наверх»: всплывающий кружок, появляется после прокрутки вниз.
         Раньше на десктопе была полоса на весь правый край, но она перехватывала
         клики по хедеру и правым кнопкам карточек на узких окнах — заменили на
         кружок. Мобильный — маленький, снизу СЛЕВА (справа внизу кнопка чата
         Chaport). Десктоп — крупный (x-large ≈ вдвое) и по центру правого края. -->
    <v-fade-transition>
      <v-btn
        v-show="showScrollTopFab"
        class="scroll-top-fab"
        fab
        :small="$vuetify.breakpoint.smAndDown"
        :x-large="$vuetify.breakpoint.mdAndUp"
        elevation="6"
        title="Наверх"
        aria-label="Наверх"
        @click="scrollToTop"
      >
        <v-icon :large="$vuetify.breakpoint.mdAndUp">{{ icons.mdiChevronUp }}</v-icon>
      </v-btn>
    </v-fade-transition>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <app-bar-search
            v-if="!hideHeaderSearch"
            :shall-show-full-search.sync="shallShowFullSearch"
            :data="upcomingList"
            :filter="searchFilterFunc"
            :search-query.sync="appBarSearchQuery"
            :object-info="objectInfo"
            @update:shallShowFullSearch="handleShallShowFullSearchUpdate(isVerticalNavMenuActive, toggleVerticalNavMenuActive)"
          ></app-bar-search>
          <!-- <p
            class="body-2 pt-4 pl-1 cursor-pointer"
            @click="shallShowFullSearch = !shallShowFullSearch"
          >
            Поиск по ref или номеру заявки
          </p> -->
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <app-bar-i18n></app-bar-i18n>
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-cart></app-bar-cart>
          <app-bar-notification></app-bar-notification>

          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between mt-4">
        <span>ООО "ФОРВАРД", &copy; {{ new Date().getFullYear() }}</span>
      </div>
      <div class="d-flex justify-center justify-md-start mt-4">
        <div class="align-center d-flex flex-wrap justify-center" style="gap: 14px">
          <v-img
            src="@/assets/images/logo1h.png"
            width="180px"
            contain
            alt="Payment methods"
          ></v-img>
          <v-img
            src="@/assets/images/logos/mir.svg"
            width="88px"
            height="24px"
            contain
            alt="МИР"
          ></v-img>
          <v-img
            src="@/assets/images/logos/sbp.svg"
            width="60px"
            height="24px"
            contain
            alt="СБП"
          ></v-img>
          <v-img
            src="@/assets/images/logos/cash.png"
            width="24px"
            height="24px"
            contain
            alt="Наличные"
            class="pay-cash-icon"
          ></v-img>
        </div>
      </div>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
import store from '@/store'
import { getVuetify, useRouter } from '@core/utils'

import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'
import navMenuItems, { licensePaymentNavItem } from '@/navigation/vertical'
import AppBarI18n from '@core/layouts/components/app-bar/AppBarI18n.vue'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'

import AppBarNotification from '@core/layouts/components/app-bar/AppBarNotification.vue'
import AppBarCart from '@core/layouts/components/app-bar/AppBarCart.vue'

import axios from '@axios'
import { mdiHeartOutline, mdiMenu, mdiChevronUp, mdiChartBox } from '@mdi/js'

// Search Data

import appBarSearchData from '@/assets/app-bar-search-data'
import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import {
  computed, ref, onMounted, watch,
} from '@vue/composition-api'
import { useWindowScroll } from '@vueuse/core'
import useFloatingClearance from '@/utils/floatingClearance'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    AppBarSearch,
    AppBarUserMenu,
    AppBarI18n,
    AppBarThemeSwitcher,

    AppBarNotification,
    AppBarCart,
  },
  setup() {
    const $vuetify = getVuetify()
    const { route } = useRouter()

    // Предзагрузка списка заявок: глобальный поиск в шапке берёт данные из
    // upcoming/getUpcomingList, который иначе наполняется только на «Заказах».
    // Тянем один раз, чтобы поиск работал в любом разделе, а не только после
    // захода на страницу «Заказы».
    if (!store.getters['upcoming/getUpcomingList'].length) {
      store.dispatch('upcoming/fetchUpcoming')
    }

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)

    // NOTE: Update search function according to your usage
    const searchFilterFunc = (item, queryText, itemText) => {
      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      return appBarSearchQuery.value && isMatched
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    // Плавно проматывает страницу к началу (к хедеру). Приложение скроллит
    // окном (useWindowScroll в layout), поэтому window.scrollTo — то что нужно.
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    // Мобильная кнопка «наверх» появляется, когда прокрутили заметно вниз
    // (~пол-экрана), чтобы не мозолила глаза, пока пользователь наверху.
    const { y: scrollY } = useWindowScroll()
    const showScrollTopFab = computed(() => scrollY.value > 400)

    const { spacer: floatingSpacer, height: floatingHeight } = useFloatingClearance()

    // Пункт «Аналитика» показывается по флагу is_analytics_admin. Флаг приходит
    // с /auth/me, и раньше попадал в localStorage ТОЛЬКО при входе — из-за этого
    // у уже залогиненных админов (старая сессия в браузере) меню не появлялось,
    // приходилось перелогиниваться. Теперь освежаем флаг при каждой загрузке
    // кабинета и добавляем пункт на лету.
    const navMenu = ref(navMenuItems)

    // Подпись у пункта «Получение лицензий» (правка начальника 02.10.2026):
    // появилась дата обучения — «Можно оплатить», оплачено без даты —
    // «Выберите дату». Живёт по хранилищу: его обновляют и раскладка, и сама
    // страница «Получение лицензий». Пункт в меню заменяем новым объектом, а
    // не правим общий объект модуля.
    const obtainingNote = computed(() => {
      if (store.getters['licenses/getObtainingReady'].length) return 'Можно оплатить'
      if (store.getters['licenses/getObtainingChooseDate'].length) return 'Выберите дату'

      return ''
    })
    watch(obtainingNote, note => {
      navMenu.value = navMenu.value.map(item => {
        if (item.to !== 'license-obtaining') return item
        const { note: oldNote, noteColor, ...plain } = item

        return note ? { ...plain, note, noteColor: 'success' } : plain
      })
    }, { immediate: true })

    onMounted(() => {
      // Хранилище живёт, пока открыта вкладка, а выход и вход идут без
      // перезагрузки страницы: подпись и плашка прежнего логина не должны
      // достаться следующему. Сбрасываем до ответа сервера.
      store.commit('licenses/set_obtaining_status', null)

      axios({ method: 'get', url: '/api/v1/auth/me' })
        .then(response => {
          const user = (response.data && response.data.data && response.data.data.user) || null
          if (!user) return

          // Мержим ТОЛЬКО флаг, чтобы не затереть локальные пометки (news_mark и пр.).
          const stored = JSON.parse(localStorage.getItem('userData') || '{}')
          stored.is_analytics_admin = user.is_analytics_admin
          stored.license_payment_enabled = !!user.license_payment_enabled

          // Карточка на «Заказах» — только в приём заявок (03.10.2026). Старый
          // сервер признака не шлёт — тогда по флагу оплаты.
          const cardVisible = user.license_card_visible === undefined
            ? !!user.license_payment_enabled
            : !!user.license_card_visible
          stored.license_card_visible = cardVisible
          localStorage.setItem('userData', JSON.stringify(stored))

          // Оплата лицензий: карточка на «Заказах» смотрит на признак в
          // хранилище, пункт меню добавляем или убираем на лету.
          store.commit('app/SET_LICENSE_PAYMENT_ENABLED', user.license_payment_enabled)
          store.commit('app/SET_LICENSE_CARD_VISIBLE', cardVisible)
          const hasLicensePayment = navMenu.value.some(item => item.to === licensePaymentNavItem.to)
          if (user.license_payment_enabled && !hasLicensePayment) {
            const items = [...navMenu.value]
            const idx = items.findIndex(item => item.to === 'license-obtaining')
            if (idx !== -1) items.splice(idx + 1, 0, licensePaymentNavItem)
            else items.push(licensePaymentNavItem)
            navMenu.value = items
          } else if (!user.license_payment_enabled && hasLicensePayment) {
            navMenu.value = navMenu.value.filter(item => item.to !== licensePaymentNavItem.to)
          }

          // Получение лицензий: если у гида есть заявки, за которыми стоит
          // следить, спрашиваем, не появилась ли дата (подпись в меню и плашка
          // на «Заказах» — по хранилищу).
          if (user.license_obtaining_watch) store.dispatch('licenses/fetchObtainingStatus')

          const hasAnalytics = navMenu.value.some(item => item.to === 'analytics')
          if (user.is_analytics_admin && !hasAnalytics) {
            const items = [...navMenu.value]
            const idx = items.findIndex(item => item.to === 'archive-requests')
            const analyticsItem = { title: 'Аналитика', icon: mdiChartBox, to: 'analytics' }
            if (idx !== -1) items.splice(idx + 1, 0, analyticsItem)
            else items.push(analyticsItem)
            navMenu.value = items
          }
        })
        .catch(() => {})
    })

    return {
      navMenuItems: navMenu,
      handleShallShowFullSearchUpdate,

      // Прячем шапочный поиск на «Истории платежей»: там есть свой поиск по платежам.
      hideHeaderSearch: computed(() => route.value.name === 'payments-history'),

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,
      scrollToTop,
      showScrollTopFab,
      floatingSpacer,
      floatingHeight,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiChevronUp,
      },
      upcomingList: computed(() => {
        const rawUpcoming = store.getters['upcoming/getUpcomingList']
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < rawUpcoming.length; index++) {
          rawUpcoming[
            index
          ].search_data = `${rawUpcoming[index].id} ${rawUpcoming[index].data.refno} ${rawUpcoming[index].data.pass_date} ${rawUpcoming[index].info.museum}`
        }

        return rawUpcoming
      }),
      objectInfo: computed(() => store.getters['upcoming/getMuseumObjectsInfo']),
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// Иконки в шапке: равные промежутки задаём gap'ом на контейнере, а не margin'ами
// на компонентах — те лежат внутри обёрток v-menu/v-badge и отступы выходят неровными.
.right-row {
  gap: 2rem;

  @media (max-width: 600px) {
    gap: 1rem;
  }
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}

// Кнопка «наверх». На мобильном — маленькая, снизу СЛЕВА (правый нижний угол
// занят кнопкой чата Chaport). На десктопе — крупная (x-large = 72px) и по
// вертикальному ЦЕНТРУ правого края (top 50% минус половина высоты кнопки).
.scroll-top-fab {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 7;

  @media (min-width: 960px) {
    left: auto;
    bottom: auto;
    right: 20px;
    top: calc(50% - 36px);
  }
}
</style>

<style lang="scss">
// Иконка «наличные»: исходный PNG белый (для тёмной темы). В светлой теме
// чернит через brightness(0), иначе на светлом фоне не видна. Правило ГЛОБАЛЬНОЕ
// и живёт в лейауте кабинета (он загружается на всех залогиненных страницах);
// одноимённое правило в Login.vue грузится только на самой странице логина.
.theme--light .pay-cash-icon {
  filter: brightness(0);
}
</style>
